/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react'
import { SwapOutlined } from '@ant-design/icons'
import {
  HomeTeam,
  VisitingTeam,
} from '@sportninja/common/types/PlayerAttendance'
import {
  roleButtonColumnStyle,
  roleButtonLabelAboveStyle,
  roleButtonContainerStyle,
  roleButtonNameStyle,
  roleButtonSwapIconStyle,
} from '../styles'
import { trackEvent, getPlatformType } from '../../../utils/analytics'
import { ROLE_ASSIGNMENT_TEXT } from '@sportninja/common/features/social/components/GameWidget/constants'

export interface SnacksInfoProps {
  isTeamRepOnTeam: boolean
  team: HomeTeam | VisitingTeam
  onPressManageRefreshments: (
    gameId: string,
    rosterId: string,
    teamId: string,
    teamName: string,
    showWaiver: boolean
  ) => void
  gameId: string
  showWaiver: boolean
  teamSide: 'home' | 'visitor'
}

const SnacksInfo: React.FC<SnacksInfoProps> = ({
  isTeamRepOnTeam,
  team,
  onPressManageRefreshments,
  gameId,
  showWaiver,
  teamSide,
}) => {
  const handleClick = useCallback(() => {
    if (!isTeamRepOnTeam) {
      return
    }
    const hasAssignment = !!(
      team?.refreshments_player?.name_full ||
      team?.refreshments_team_official?.name_full
    )
    trackEvent('home_game_card_refreshments_tapped', {
      platform: getPlatformType(),
      game_id: gameId,
      team_side: teamSide,
      has_assignment: hasAssignment,
    })
    onPressManageRefreshments(
      gameId,
      team?.game_roster_id,
      team?.id,
      team?.name,
      showWaiver
    )
  }, [
    isTeamRepOnTeam,
    onPressManageRefreshments,
    gameId,
    team,
    showWaiver,
    teamSide,
  ])

  const assignedName = team?.refreshments_player?.name_full
    ? team?.refreshments_player?.name_full
    : team?.refreshments_team_official?.name_full
    ? team?.refreshments_team_official?.name_full
    : isTeamRepOnTeam
    ? ROLE_ASSIGNMENT_TEXT.TEAM_REP
    : ROLE_ASSIGNMENT_TEXT.NOT_SET

  return (
    <div css={roleButtonColumnStyle}>
      <p css={roleButtonLabelAboveStyle}>Drinks/Snacks</p>
      <div
        css={roleButtonContainerStyle(isTeamRepOnTeam)}
        onClick={handleClick}
      >
        <p css={roleButtonNameStyle}>{assignedName}</p>
        {isTeamRepOnTeam ? (
          <SwapOutlined css={roleButtonSwapIconStyle} />
        ) : null}
      </div>
    </div>
  )
}

export default React.memo(SnacksInfo)
